<template >
  <div class="container-flight">
    <div ref="hoteldata" id="hoteldata">
       <div style="
        text-align: initial;
        margin-bottom: 15px;
        margin-top: 10px;
      ">
        <img width="200" height="50" src="../../../public/img/logo-pardis.png" alt="">
      </div>
      <div style="text-align: center;" class="card">
        <div class="card-header">
          <span class="float-right">
            <i class="icon-star"></i> <span>مشخصات اقامت</span>
          </span>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <strong style="justify-content: center">{{
                  selectedHotel[0].hotelName
              }}</strong>
            </div>
            <br></br>
            <div class="col-4">
              <p> از تاریخ :
                {{ startDate }}
              </p>

            </div>
            <div class="col-4">

              <p>تا تاریخ :
                {{ endDate }}
              </p>
            </div>
            <div class="col-4">

              <p>تعداد اقامت :
                {{ totalNight }} شب
              </p>
            </div>
          </div>

          <div style="padding: 25px 50px;" class="col-12">

            <div class="table-responsive-sm">
              <table style="text-align: right;" class="table table-striped">
                <thead>
                  <tr>

                    <th class="right">نوع اتاق</th>
                    <th class="right">مبلغ اتاق</th>
                    <th class="right"> تخفیف</th>
                    <th class="right">جمع </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(room, index) in selectedHotel" :key="index">

                    <td class="right">
                      {{ room.name }}
                    </td>

                    <td class="right">
                      {{ room.totalBasePrice | numFormat | rial }}
                    </td>
                    <td class="right">
                      {{ room.totalBasePrice - room.discount | numFormat | rial }}
                    </td>
                    <td class="right">
                      {{ room.totalFarePrice | numFormat | rial }}
                    </td>

                  </tr>

                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-5"></div>

              <div class="col-lg-4 col-sm-5 ml-auto">
                <table class="table table-clear">
                  <tbody>
                    <tr>
                      <td class="left">
                        <strong>جمع کل</strong>
                      </td>
                      <td class="right">
                        <strong style="font-size: 19px; color: #07557c">
                          {{ sumOfRoomPrice * totalNight | numFormat | rial}} 
                        </strong>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-12">
            <button style="width: 150px;" type="submit" class="btn btn-primary" @click="toPDF">دانلود فایل</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>



import store from "../../views/hotel/store/index";
import exportFiles from "../../utils/exportFiles";
import date from "../../utils/date";
import moment from "moment";



var qs = require("qs");

export default {
  name: "HotelBook",
  components: {

  },
  store,
  data() {
    return {


      selectedRoom: [],



      searchItems: {},
      params: {},
      forms: new Array(),
      selectedHotel: {},
      startDate: "",
      endDate: "",
      hotelId: "",
      bookingDetails: {},
      guestRequest: "",
      checkValid: false,
      checkValidTransfer: false,
      isValidForm: false,
      isValidTransferForm: false,
      transferInfoForm: {},
      hotelList: [],
      cityList: [],
      roomsList: [],
      showCombineRoom: false,
      totalNight: 0,


    };
  },

  created() {
 
    this.params = this.$route.query;
    this.selectedHotel = this.$store.getters["hotel/GetSelectedHotelRoom"];
    const hotelInfo = this.$store.getters["hotel/GetHotelDetails"];


    // this.createRequest();

    var bookingDetail = this.$store.getters["hotel/GetHotelBookingDetails"];

    this.calculateTotalNight();

  },
  methods: {
    toPDF() {
      var fileName = 'PDK_hotel'
      exportFiles.ExportToPDF(this.$refs.hoteldata, fileName, null, null);

    },
    roomCount(array) {
      let counts = array.reduce(
        (out, { name }) => ({ ...out, [name]: out[name] + 1 || 1 }),
        {}
      );
      return Object.keys(counts).map((key) => ({
        name: key,
        count: counts[key],
      }));
    },




    

    calculateTotalNight() {
      this.startDate = date.ConvertToPersian(this.params.startDate);
      this.endDate = date.ConvertToPersian(this.params.endDate);
      let fDate = this.params.startDate;
      let tDate = this.params.endDate;
      this.fromDate = date.ConvertToPersian(fDate);
      this.toDate = date.ConvertToPersian(tDate)
      this.totalNight = 0;
      if (
        fDate != "" &&
        fDate != null &&
        tDate != "" &&
        tDate != null
      ) {

        var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

        let diff = Math.round(duration.asDays());

        this.totalNight = diff;
      } else {
        this.totalNight = 0;
      }
    },


  },
  computed: {
    sumOfRoomPrice() {
      var total = 0;
      this.selectedHotel.forEach(element => {
        total = total + element.totalFarePrice;
      });
      return total;
    },
    filteredRooms() {
      return this.roomCount(this.selectedHotel);
    },
    roomTotalPrice() {
      return this.calcRoomTotalPrice(this.selectedHotel);
    },

    packageTotalPrice() {
      var roomPrice = this.calcRoomTotalPrice(this.selectedHotel);
      var totalRoom = roomPrice * this.totalNight;

      return totalRoom;
    },
  },

};
</script>
<style  scoped >

.search-box {
  position: relative;
  z-index: 0 !important;
  padding-bottom: 40px;
}
</style>
